export default __webpack_public_path__ + "static/media/hu.cb329e88.svg";